import { Injectable } from '@angular/core';

@Injectable()
export class DialogStatusService {

  inputFocused = false;
  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/dialog-status.service.ts